module.exports = __webpack_public_path__ + "static/media/Diagnostic_Results.f3311728.gif";